export interface AddToShoppingListFormResult {
  productQuantity: number;
  shoppingList: string;
  newListName?: string;
}

export const NewShoppingListId: string = 'new';
